import validator from 'validator';

export const validateEmail = (email: string): boolean => {
  return email ? validator.isEmail(email) : true;
};

/**
 * formats a string or an array of emails or phone numbers
 * @param value
 */
export const formatInput = (input: string | string[]): string[] => {
  let output: typeof input;

  if (typeof input === 'string') {
    output = input.split(',');
  } else {
    output = input;
  }

  return output.reduce(
    (values, currentValue) =>
      currentValue.trim()
        ? [...values, currentValue.trim().toLowerCase()]
        : values,
    [] as string[]
  );
};

export const validateEmails = (value: string | string[]): boolean => {
  if (!value) return true;
  const emails = formatInput(value);

  return emails.every(validateEmail);
};
